import React from 'react'

const TitleWorkServices = () => {
  return (
    <h1 className='TitlePrincipal'>Work <br /> Services</h1>
  )
}

export default TitleWorkServices
